import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LatitudeUIGeoLogoMiniComponent } from './geo-logo-mini.component';

@NgModule({
  declarations: [LatitudeUIGeoLogoMiniComponent],
  exports: [LatitudeUIGeoLogoMiniComponent],
  imports: [CommonModule]
})
export class LatitudeUIGeoLogoMiniModule { }



// WEBPACK FOOTER //
// ./src/latitude-ui/geo-logo-mini/geo-logo-mini.module.ts